var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 24a2.25 2.25 0 0 1-2.25-2.25v-9a.75.75 0 0 1 1.5 0v3.75h11.25v-3.75a.75.75 0 0 1 1.5 0v9.75h4.5a.75.75 0 0 0 .75-.75v-9a.75.75 0 0 1 1.5 0v9A2.25 2.25 0 0 1 20.25 24zM3 21.75a.75.75 0 0 0 .75.75h10.5V18H3zM21.148 0a1.5 1.5 0 0 1 1.464 1.174l1.37 6.163L24 7.5a3 3 0 0 1-5.25 1.984 3 3 0 0 1-4.5 0 3 3 0 0 1-4.5 0 3 3 0 0 1-4.5 0A3 3 0 0 1 0 7.5l.018-.163 1.369-6.164A1.5 1.5 0 0 1 2.852 0zm0 1.5H2.852L1.5 7.574a1.5 1.5 0 0 0 3-.074.75.75 0 0 1 1.5 0 1.5 1.5 0 0 0 3 0 .75.75 0 0 1 1.5 0 1.5 1.5 0 0 0 3 0 .75.75 0 0 1 1.5 0 1.5 1.5 0 0 0 3 0 .75.75 0 0 1 1.5 0 1.5 1.5 0 0 0 3 .074z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStore);
export default __webpack_public_path__ + "static/media/icon-store.a1776eef.svg";
export { ForwardRef as ReactComponent };